// @flow

import React from 'react';
import glamorous from 'glamorous';
import { connect } from 'react-redux';
import { map } from 'lodash/fp';
import Loader from 'app/components/commons/Loader';
import Rows from 'app/components/layout/Rows';
import ScoringContentRow from 'app/components/static/ScoringContentRow';
import oneScoreImage from 'app/images/app/onescore.png';

type Props = {
  bonuses: Array<Object>,
  isLoading?: boolean,
  onescore?: boolean,
  scoringInfo?: Array<Object>,
};

const defaultProps = {
  isLoading: false,
  scoringInfo: [],
  onescore: false,
};

const mapBonuses = map(b => ({
  name: b.description,
  value: b.rulesDescription,
}));

const Content = glamorous.div({
  position: 'relative',
});

const Placeholder = glamorous.div({
  textAlign: 'center',
});

const OneScoreImage = glamorous.img(({ theme }) => ({
  height: 32,
  marginTop: theme.spacing.default,
  marginLeft: theme.spacing.default,
  width: 180,
  [theme.mediaQuery.desktopAndUp]: {
    bottom: 0,
    margin: 0,
    position: 'absolute',
    right: theme.spacing.large * 2,
  },
}));

const ColumnWrapper = glamorous.div(({ theme }) => ({
  paddingBottom: theme.spacing.default,
  [theme.mediaQuery.desktopAndUp]: {
    paddingRight: theme.spacing.large,
  },
}));

function ScoringContent({ bonuses, isLoading, scoringInfo, onescore }: Props) {
  if (isLoading) {
    return <Loader kind="dark" />;
  }

  if (scoringInfo.length === 0) {
    return (
      <Placeholder>
        Scoring not found
      </Placeholder>
    );
  }

  return (
    <Content>
      <Rows desktop={3} mobile={1}>
        {scoringInfo.map(scoring => (
          <ColumnWrapper key={scoring.name}>
            <ScoringContentRow items={scoring.value} title={scoring.name} />
          </ColumnWrapper>
        ))}
        {bonuses.length > 0 && (
          <ColumnWrapper>
            <ScoringContentRow items={bonuses} title="Bonuses" />
          </ColumnWrapper>
        )}
        {onescore && <OneScoreImage src={oneScoreImage} alt="One Score" />}
      </Rows>
    </Content>
  );
}

function mapStateToProps({ settings }, { bonuses }) {
  return {
    onesport: settings.onesport,
    bonuses: mapBonuses(bonuses || []),
  };
}

ScoringContent.defaultProps = defaultProps;

export default connect(mapStateToProps)(ScoringContent);
